import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { postLoginPath } from "@/lib/sgPreliveMode";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.access_token, data.user);
      navigate(postLoginPath());
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit} data-testid="login-form">
        <div className="brand-mark">INV</div>
        <h1 className="login-title">Inventory System</h1>
        <p className="login-sub">Masuk untuk melanjutkan</p>

        {error && (
          <div className="alert-error" data-testid="login-error">
            {error}
          </div>
        )}

        <label className="field-label">Email</label>
        <input
          className="field-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="email@perusahaan.com"
          required
          data-testid="login-email-input"
        />

        <label className="field-label">Password</label>
        <input
          className="field-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
          data-testid="login-password-input"
        />

        <button className="btn-primary" type="submit" disabled={loading} data-testid="login-submit-button">
          {loading ? "Memproses..." : "Masuk"}
        </button>
      </form>
    </div>
  );
}
